import React from 'react';
import $ from 'jquery';
import '../../reveal_modal/jquery-reveal-modal';

class VideoImage extends React.PureComponent {
  componentDidMount() {
    this.initRevealModal();
  }

  initRevealModal() {
    const videoId = this.props.id;

    $(document).on('click', `[data-reveal-id="video-modal-${videoId}"]`, (e) => {
      e.stopPropagation();
      e.preventDefault();

      const $reveal = $(`#video-modal-${videoId}`);

      // trigger loading of the iframe on opening the reveal
      $reveal.off('reveal:open').bind('reveal:open', function loadIframe() {
        const videoContainer = this.querySelectorAll('.video-responsive')[0];

        if (videoContainer) {
          videoContainer.click();
        }
      });

      // remove iframe when closing the reveal
      $reveal.off('reveal:close').bind('reveal:close', function removeIframe() {
        const videoIframe = this.querySelectorAll('.video-responsive iframe')[0];

        if (videoIframe) {
          $(videoIframe).remove();
        }
      });

      $reveal.reveal();
    });
  }

  render() {
    return (
      <a
        href="javascript:void(0);"
        className="video-preview"
        data-reveal-id={`video-modal-${this.props.id}`}
      >
        <img src={this.props.url} alt={this.props.alt} className="img-responsive" />
        <i className="play-button" />
      </a>
    );
  }
}

VideoImage.propTypes = {
  id: React.PropTypes.string,
  url: React.PropTypes.string,
  alt: React.PropTypes.string
};

export default VideoImage;



// WEBPACK FOOTER //
// ./components/videos/videoImage.js